<template lang="pug">
    v-stepper(v-model="step" v-if="content")
        v-stepper-items
            v-stepper-content(step="1")
                v-container(grid-list-md)
                    v-layout(wrap)
                        v-flex(lg6 md6 xs12)
                            v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="warning") mdi-credit-card-multiple-outline
                        v-flex(lg5 md5 xs12)
                            v-text-field(dense v-model="content.summary.productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg6 md6 xs12 v-if="content.note")
                            v-text-field(dense v-model="content.note" label="Berita" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-note-text-outline
                        v-flex(lg5 md5 xs12 v-if="content.customerRef")
                            v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-file-document-outline
                    v-layout(wrap)
                        v-flex(lg4 md4 xs12)
                            v-text-field(dense v-model="content.info.noDokumen" label="No. Transaksi" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12)
                            v-text-field(dense v-model="content.info.kasdaId" label="Kode Pemda" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12)
                            v-text-field(dense v-model="content.info.tahun" label="Tahun" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg3 md3 xs12)
                            v-text-field(dense v-if="content.info.npwp" v-model="content.info.npwp" label="NPWP" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg6 md6 xs12 v-if="content.info.namaSub")
                            v-text-field(dense v-model="content.info.namaSub" label="Dinas" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-account-details-outline
                        v-flex(lg11 md11 xs12)
                            v-text-field(dense v-model="content.info.keterangan" label="Keterangan" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                    v-layout(wrap v-if="content.info.dataUpload")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="content.info.dataUpload.amount" label="Nominal" readonly :template="true")
                    v-layout(wrap v-if="content.info.dataUpload")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="content.info.dataUpload.fee" label="Biaya Admin" readonly :template="true")
                    v-layout(wrap v-if="content.info.dataUpload")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="content.info.dataUpload.total" label="Total" readonly :template="true")
                    v-flex(lg12 md12 xs12 v-if="content.info.dataUpload")
                        v-dialog(v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
                            template(v-slot:activator="{ on, attrs }")
                                div(justify-center style="text-align: center" class="ma-2 menu-btn")
                                    v-btn(color="btnprimary white--text" class="mx-1" v-bind="attrs" v-on="on") Detail Transaksi
                            v-card(style="width:100%" elevation="6")
                                v-toolbar(class="primary--text" dense)
                                    v-toolbar-title(class="title-text") DETAIL TRANSAKSI
                                    v-spacer
                                    div(justify-center style="text-align: center" class="ma-2 menu-btn")
                                        v-btn(class="mx-1" @click="dialog = false") Kembali
                                            v-icon mdi-arrow-left-circle
                                v-container(grid-list-md)
                                    f-upload-transaction-table(:upload="content.info.dataUpload" :payrollStatus="payrollStatus")
</template>
<script>
export default {
    name: "FPemdaTransactionPaymentContent",
    props: ["content", "request", "transaction", "edit", "reinquiry", "reverse", "status"],
    data() {
        return {
            step: "1",
            readonly: false,
            dialog: false,
        }
    },
    computed: {
        source() {
            return this.$options.filters.accountformat(this.content.source) + (this.content.sourceName ? (" - " + this.content.sourceName)
                : (" - " + this.request.data.sourceName));
        }
    },
    watch: {
        content(val){
            this.doReset();
        }
    },
    mounted() {
        this.doReset();
    },
    methods: {
        doReset(){
            this.step = "1";
            this.$emit("showButton");
        },
        emitEvents(event) {
            this.$emit(event);
        },
    }
}
</script>
